import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import {i18n} from "../../../vue-i18n";

export default class ChangeRentRate {
  constructor(paymentParametersId, rateValue) {
    this.commandName = "ChangeRentRate";
    this.paymentParametersId = paymentParametersId;
    this.rateValue = rateValue;

    this.description =
      `${i18n.t('CONTENT.discountRates.rate')}: ${rateValue}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewRate: this.rateValue
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
